import React, {useRef} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled';
import Slider from "react-slick";
import QuoteIcon from '~images/quote-icon.svg'
import NextArrow from '~images/slider-next-arrow.svg'
import { AmplitudeCounter } from "~/amplitude-counter";

const ReviewsScreen = () => {
  const sliderRef = useRef(null)

  const reviews = [
    {
      text: 'Большое спасибо за качественную тех. поддержку, отдельная благодарность Ивану - настоящий профессионал своего дела, выполнил свою работу на 100/10.',
      name: 'Тарасов Владимир',
      date: '22.10.2024'
    },
    {
      text: 'Все работает на 5+. Тех. поддержка работает ВЕЛИКОЛЕПНО! Быстрая обратная связь, оперативные ответы на вопросы. Рекомендую.',
      name: 'Светлана',
      date: '19.09.2024'
    },
    {
      text: 'Из за этой команды у меня теперь высокие запросы для других разработчиков. Вы лучшие.',
      name: 'Мансур Гизатуллин.',
      date: '10.04.2024'
    },
    {
      text: 'Поддержка работает быстро и эффективно',
      name: 'Shoikrom',
      date: '23.03.2024'
    },
    {
      text: 'Лучшая виртуальная АТС Хочу выразить благодарность каждому сотруднику. За свой профессионализм и отличное обслуживание',
      name: 'Маркетинг',
      date: '03.10.2023'
    }
  ]

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    useCSS: true,
    adaptiveHeight: true,
    appendDots: (dots: any) => (
      <Styled.Dots>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </Styled.Dots>
    ),
    customPaging: (i: number) => (
      <Styled.Dot />
    ),
    afterChange: () => AmplitudeCounter('view_feadback_onlinepbx')
  };

  const next = () => {
    if (sliderRef) sliderRef.current.slickNext()
  }

  return (
    <Screen
      title={<span>Клиенты<StyledScreen.GreenText> о нас:</StyledScreen.GreenText></span>}
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Slider>
          <Slider ref={sliderRef} { ...sliderSettings }>
            {
              reviews.map(review => (
                <Styled.Slide>
                  <Styled.Quote><QuoteIcon /></Styled.Quote>
                  <Styled.SlideInner>
                    <Styled.SlideText>{review.text}</Styled.SlideText>
                    <Styled.SlideFooter>
                      <Styled.Author>{review.name}</Styled.Author>
                      <Styled.Date>{review.date}</Styled.Date>
                    </Styled.SlideFooter>
                  </Styled.SlideInner>
                </Styled.Slide>
              ))
            }
          </Slider>
          <Styled.Next onClick={next}><NextArrow /></Styled.Next>
        </Styled.Slider>
      </Styled.Container>
    </Screen>
  )
}

export { ReviewsScreen }